import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-customer-event-table',
  template: `
    <table>
      <thead>
        <tr>
          <th>Event Type</th>
          <th>Email</th>
          <th>SMS</th>
          <th>WhatsApp</th>
        </tr>
      </thead>
      <tbody *ngIf="rowData.length > 0; else noRows">
    <tr *ngFor="let row of rowData">
      <td>{{ row.event }}</td>
      <td>
        <input  class="custom-check"  type="checkbox" (change)="onCheckboxChange(row, 'isemail')" [checked]="row.isemail" [disabled]="row.isemaildisable">
      </td>
      <td>
        <input  class="custom-check" type="checkbox" (change)="onCheckboxChange(row, 'issms')" [checked]="row.issms" [disabled]="row.issmsdisable">
      </td>
      <td>
        <input  class="custom-check" type="checkbox" (change)="onCheckboxChange(row, 'iswhatsapp')" [checked]="row.iswhatsapp" [disabled]="row.iswhatsappdisable">
      </td>
    </tr>
  </tbody>
  <ng-template #noRows>
    <tr>
      <td colspan="4" class="now-rows">No rows to show</td>
    </tr>
  </ng-template>
    </table>

  `,
  styles: [
    `
      table {
        border-collapse: collapse;
        width: 100%;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
      }

      th {
        color: white;
        background-color: #25476a;
      }
      .now-rows{
        color: black;
        text-align: center;
      }

      .custom-check{
        margin-right: 5px; width: 16px; height: 16px;
      }
    `,
  ],
})
export class CustomerEventTableComponent implements OnInit {
  @Input() rowData: any[] = [];
  @Output() rowSelected = new EventEmitter<any>();

  ngOnInit(): void {

  }

  onCheckboxChange(row: any, property: string): void {
    row[property] = !row[property];
    this.rowSelected.emit(this.rowData);
  }
}

